import { render, staticRenderFns } from "./addLimitDialog.vue?vue&type=template&id=45b7cd6e&scoped=true"
import script from "./addLimitDialog.vue?vue&type=script&lang=js"
export * from "./addLimitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7cd6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b7cd6e')) {
      api.createRecord('45b7cd6e', component.options)
    } else {
      api.reload('45b7cd6e', component.options)
    }
    module.hot.accept("./addLimitDialog.vue?vue&type=template&id=45b7cd6e&scoped=true", function () {
      api.rerender('45b7cd6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/canteen-product/components/addLimitDialog.vue"
export default component.exports